import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import getLocalStorageApi from 'api/browser/localstorage/get';
import { LOCALSTORAGE } from 'constants/localStorage';

let nextSessionId = 0;

export const useLogAccessSession = (): {
	id: number;
	authenticated: boolean;
} => {
	const queryClient = useQueryClient();
	const [session, setSession] = useState(() => ({
		id: nextSessionId++,
		authenticated: Boolean(getLocalStorageApi(LOCALSTORAGE.AUTH_TOKEN)),
	}));

	useEffect(() => {
		const changed = (): void => {
			// Clear previous-account data, including in-flight queries, before mounting
			// either application. Tokens themselves never become query cache keys.
			queryClient.clear();
			setSession({
				id: nextSessionId++,
				authenticated: Boolean(getLocalStorageApi(LOCALSTORAGE.AUTH_TOKEN)),
			});
		};
		const storageChanged = (event: StorageEvent): void => {
			if (!event.key || event.key.endsWith(LOCALSTORAGE.AUTH_TOKEN)) {
				changed();
			}
		};
		window.addEventListener('AFTER_LOGIN', changed);
		window.addEventListener('LOGOUT', changed);
		window.addEventListener('storage', storageChanged);
		return (): void => {
			window.removeEventListener('AFTER_LOGIN', changed);
			window.removeEventListener('LOGOUT', changed);
			window.removeEventListener('storage', storageChanged);
		};
	}, [queryClient]);
	return session;
};
